import type { Sleeve } from '@/portfolio/proposal-builder/types'

import { Currency } from '@moment/trading-types/reference-data'

import { getSleeveCurrency } from '@/portfolio/proposal-builder/data/transformers/global-constraints'
import {
  getFormattingCurrency,
  useProposalBuilderStoreV2,
} from '@/portfolio/proposal-builder/stores/proposal-store'
import { CURRENCY_SYMBOLS } from '@/shared/constants/international'

/**
 * Read the current currency code imperatively (outside React components).
 * Use `useProposalBuilderStoreV2.use.currencyCode()` in components instead.
 */
export function getCurrencyCode(): string {
  return getFormattingCurrency(useProposalBuilderStoreV2.getState())
}

/**
 * Read the current currency symbol imperatively (outside React components).
 * Use `useProposalBuilderStoreV2.use.currencySymbol()` in components instead.
 */
export function getCurrencySymbol(): string {
  return CURRENCY_SYMBOLS[getCurrencyCode()] ?? '$'
}

/**
 * Symbol for one sleeve's own currency. Rows that list several sleeves at once
 * must use this, not the active scope's symbol.
 */
export function getSleeveCurrencySymbol(sleeve: Sleeve | undefined): string {
  return CURRENCY_SYMBOLS[getSleeveCurrency(sleeve) ?? Currency.USD] ?? '$'
}
